import axios from 'axios';
import extend from './extend.js';
import distinct from './distinct.js';
import { dummy } from './dummy.js';

const certificatecode = '510001';
const otherSchools = 'その他の高校';
const otherSchoolsType = '9';

// import $ from 'jquery';

const tmpl = items => `
  <div class="incremental-search-wrap">
    <div class="incremental-search-scrollable">
      <ul class="incremental-search">
      ${items.map(item => `
          <li><a href="#" tabindex="11" data-type="${item.school_type}" data-name="${item.school_name_full}" data-code="${item.school_code}">${item.school_name_full}${item.school_prefecture_name ? `（${item.school_prefecture_name}）` : ''}</a></li>
      `).join().replace(/,/g,'')}
      </ul>
    </div>
  </div>
`;

const resultTmpl = (type, code, name) => `
  <input type="hidden" name="ufd_hs_type" value="${type}" />
  <input type="hidden" name="ufd_hs_code" value="${code}" />
  <input type="hidden" name="ufd_hs_name" value="${name}" />
`;

const otherTmpl = (items) => `
    <div class="contact-form-grid acms-margin-top-small p-other-highschool-select-input">
      <div class="contact-form-col2">
        <select class="contactSelector js-school-other-select">
          ${items.map(item => `
            <option value="${item.school_code}">${item.school_prefecture_name}</option>
          `).join().replace(/,/g,'')}
        </select>
      </div>
      <div class="contact-form-col2">
        <div class="c-form-input-wrap p-other-school-input-wrap">
          <i class="fa fa-school"></i>
          <input type="text" class="js-school-other-input" placeholder="その他の高校名" />
        </div>
      </div>
    </div>
`;

export default class SchoolSearch {
  constructor(url, selector, result, hidden, other) {
    this.items = [];
    this.params = {};
    this.url = url;
    this.done = false;
    this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;
    this.result = typeof result === 'string' ? document.querySelector(result) : result;
    this.hidden = typeof hidden === 'string' ? document.querySelector(hidden) : hidden;
    this.other = typeof other === 'string' ? document.querySelector(other) : other;
    this.fetch();
    $(this.selector).on('input',this.input.bind(this));
    $(this.selector).on('compositionend',this.input.bind(this));
    $(this.result).on('mousedown','a', (e) => {
      e.preventDefault();
      const $target = $(e.target);
      this.registerResult($target);
    });
    $(this.result).on('focus','a', (e) => {
      e.preventDefault();
      const $target = $(e.target);
      this.registerResult($target);
    });

    $(this.selector).on('blur', (e) => {
      setTimeout(() => {
        if(this.done) {
          return;
        }
        $(this.result).hide();
        const $li = $('li',this.result);
        if($li.length > 0) {
          const $target = $li.first();
          const $a = $('a',$li);
          this.registerResult($a);
        } else {
        // blur時に空だった場合の動作
          $('.js-highschool-eror-text').show();
        }
        $(this.selector).trigger('input');
      },300);
    });
    $(this.other).on('input','input', this.inputOtherResult.bind(this));
    $(this.other).on('change','select', this.inputOtherResult.bind(this));
  }

  input() {
    $(this.result).show();
    $(this.selector).removeClass('js-school-search-success');
    const keyword = this.selector.value;
    this.done = false;
    this.setParams({ keyword });
    this.search();
    this.render();
  }

  registerResult($target) {
    this.done = true;
    this.selector.value = $target.html();
    $(this.selector).addClass('js-school-search-success');
    $(this.result).hide();
    if (`${$target.data('type')}` === otherSchoolsType && `${$target.data('code')}` !== certificatecode && $target.data('name').indexOf('外国') === -1) {
      $(this.other).show();
      this.showInput();
    } else {
      $(this.other).hide();
      this.hidden.innerHTML = resultTmpl($target.data('type'), $target.data('code'), $target.data('name'));
      // 候補をクリックしたときに高校名が空でなかったときの動作
      $('.js-highschool-eror-text').hide();
    }
  }

  setParams(params) {
    this.params = extend({}, this.params, params);
  }

  fetch() {
    const params = {
      keyword: ''
    }
    if (location.host === 'nucb.sampleple.com' || location.host === 'nucb.lab') {
        const item = {
          data: dummy
        }
        const school = item.data.school;
        school.sort((a, b) => {
          if (a.school_code === certificatecode) {
            return 1;
          } else if (a.school_name_kana < b.school_name_kana) {
            return -1;
          } else {
            return 1;
          }
        })
        this.items = school;
        this.items.push({
          school_name_full: otherSchools,
          school_type: otherSchoolsType
        });
        if (this.selector && this.selector.value) {
          // $(this.selector).trigger('blur');
        }
    } else {
      axios.get(this.url, { params }).then((item) => {
        const school = item.data.school;
        school.sort((a, b) => {
          if (a.school_code === certificatecode) {
            return 1;
          } else if (a.school_name_kana < b.school_name_kana) {
            return -1;
          } else {
            return 1;
          }
        })
        this.items = school;
        this.items.push({
          school_name_full: otherSchools,
          school_type: otherSchoolsType
        });
        if (this.selector.value) {
          // $(this.selector).trigger('blur');
        }
      });
    }
  }

  search(items) {
    if(!items) {
      return [];
    }
    return items.filter((item) => {
      if(item.school_organize === otherSchoolsType && item.school_code !== certificatecode) {
        return false;
      }
      if(item.school_name_full.indexOf(this.params.keyword) !== -1) {
        return true;
      }
      return false;
    }).slice(0, 40);
  }

  showInput() {
    const prefs = this.getPrefFromItems(this.items);
    this.other.innerHTML = otherTmpl(prefs);
  }

  inputOtherResult() {
    const items = this.items;
    const $select = $(this.other).find('select');
    const $input = $(this.other).find('input');
    const code = $select.val();
    const pref = $select.children(':selected').text();
    const name = $input.val() +  '（' + pref + '）';
    this.hidden.innerHTML = resultTmpl(otherSchoolsType, code, name);
  }

  getPrefFromItems(items) {
    const reduced = items.filter((item) => {
      if(item.school_prefecture_name && item.school_organize_label === 'その他') {
        return true;
      }
      return false;
    });
    return reduced.sort((a, b) => a.school_prefecture_code > b.school_prefecture_code ? 1 : -1);
  }

  render() {
    const items = this.search(this.items);
    if (this.selector.value.length >= 1) {
      this.result.innerHTML = tmpl(items);
    } else {
      this.result.innerHTML = '';
    }
  }
}
